import { Navigate, useLocation } from "react-router-dom";


function decodeToken(token) {
  try {
    const payload = token.split(".")[1];
    const decoded = JSON.parse(atob(payload.replace(/-/g, "+").replace(/_/g, "/")));
    return decoded;
  } catch {
    return null;
  }
}

function isTokenValid(token) {
  if (!token) return false;

  const decoded = decodeToken(token);
  if (!decoded) return false;

  if (decoded.role !== "admin") return false;

  
  if (decoded.exp && decoded.exp * 1000 < Date.now()) return false;

  return true;
}

export default function RequireAdminAuth({ children }) {
  const location = useLocation();
  const token = localStorage.getItem("adminToken");

  if (!isTokenValid(token)) {
    localStorage.removeItem("adminToken"); 
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  return children;
}